var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDivider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1106_544",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1106_544",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAACz0lEQVR4nO2cwU7cMBCG/1aQU8WZPmFLeQCOcGP7HH0WaKE99hFYuLMrcaq2hyhSNjiJ7fHYnuT/JF9WmnjybdaxxysDhBBCCCGEEEIIISQlDYBLAD8B7AEcKmt7APcAvgE4VXKgzmcAf1Bepm/7DeBcxYQiDWxJ7tojjD3ZlygvLbZdKPhQ4xfKC4tt96E3+yE0ICE7AJ8K9i9hB+AsJKCk6MPI5yVzcpEkz48JEiEeUHQmKDoTFJ0Jis6ERLS0RkE80KxR1EaxPLVrFLVRLE/NGsVWKecbQWwx0Zo1ilulnA+Il11M9G6ic8mTvEE7LGnQ9RMju5hoK2Nrn36eG0EsRc8wzDVENkUH4MrXV/ZiRTcAvgN4RrqxeyxnnzF7saI3jmuHjqtDpl7Ec7IXK/rZce0X4TXnZj1TX2SS+62xqOS6iX/Kfb4pXz+KEkOHdCHDocNBg1b2FnwZLmJ6dy2IpegRYiW7Yil6gljJw9hViJYsZELG5LHY1YiWLGRiJXexqxK9dfTpu1FgsvCfumNfCS7RT4J+fVmE6JuAWI2FjA/mRXeSfWM1FjI+mBbdl2xpamhK9FAyRSt07JJM0Yk7HpMsTVpjR6aPKdFTkqVJa+zI9DEjek6yNGmNHZk+SXLOscOivXvhumntHZksWBg6Ui5kzAwdHZovQ82FjDnRAHAliC2FSdGAW3bNmBUNvJddM6ZFA+FFpVD6C5m56WVoe1XK+YiU33BImTQU12wkVbtTyvmI1D8lye7HFK6NglTtq1LORxQbswLRkvyATAejrFn0AzIe9bM20Tu0Y/IXCJ7kk9hAwxQ5D6TGv+0uEorOBEVngqIzQdGZiJl17OE+Rq3GKd6QLDUKFzFP9N/kWeSjWO4xon8kzyIfpnJv0J46q1VLMF+jSMk52lNnS8urskaRmlO0p87eQecMjypqFIQQQgghhBBCCCHkPf8BdRfdKzKw+EsAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.d298f7f26f2550c1d3c46f9583c3568d.svg";
export { ForwardRef as ReactComponent };